import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from '../shared/error';
import { internalLayersKeys } from './queryKeys';
import { layerNodesKeys } from 'hooks/layerNode/queryKeys';

export function useDeleteInternalLayerMutation() {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, { internalLayerId: UUID }>({
    mutationFn: async ({ internalLayerId }) => {
      await axios.delete(
        `${config.apiGateway.internal_layers}/${internalLayerId}`
      );
    },
    onSuccess: () => {
      toast.success('Internal layer deleted');
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: internalLayersKeys.all() });
      queryClient.invalidateQueries({ queryKey: layerNodesKeys.all() });
    },
  });
}
